export default "__VITE_ASSET__HPSuskT3__"